import React, { useContext, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as actions from '../../_redux/pasoUno/pasoUnoActions';
//import * as actionsInscripcion from '../../_redux/inscripcion/inscripcionActions';
import { useSnackbar } from 'notistack';

import { PreInscripcionUIConsumer, PreInscripcionUIContext } from '../../PreInscripcionUIContext';
//BOTONES
import Volver from '../../components/Volver';
import Continuar from '../../components/Continuar';

//ISO PAISES/PROVINCIAS
import Countries from '../../../../../../_metronic/countries/Countries';

import SnackBarCustom from '../../../../Comun/SnackBars/SnackBarCustom';

//Formik
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useEffect } from 'react';
//Formateo loas paises a array
const paises = Countries();

const Domicilio = (props) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [siguientePaso, setSiguientePaso] = useState(false);
    const { cantidadResponsables } = useContext(PreInscripcionUIContext);
    const { tipo, posicion, currentStep, nextStep, setCantidad } = props;
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const domicilioSchema = Yup.object().shape({
        calle: Yup.string()
            //.max(maxCalle, `No debe ingresar más de ${maxCalle} caracteres`)
            .required("Debe ingresar la calle del domicilio"),
        numero: Yup.string()
            //.max(maxNumero, `No debe ingresar más de ${maxNumero} caracteres`)
            .required("Debe ingresar la numeración del domicilio"),
        /* DEPARTAMENTO Y PISO DEJAN DE SER OBLIGATORIO. JUAN 30/11/2020
        piso: Yup.string()
            //.max(maxPiso, `No debe ingresar más de ${maxPiso} caracteres`)
            .required("Debe ingresar el piso del domicilio"),
        departamento: Yup.string()
            //.max(maxDepartamento, `No debe ingresar más de ${maxDepartamento} caracteres`)
            .required("Debe ingresar el departamento del domicilio"),*/
        localidad: Yup.string()
            //.max(maxLocalidad, `No debe ingresar más de ${maxLocalidad} caracteres`)
            //.matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g, "La localidad debe estar compuesta solo por letras")
            .required("Debe ingresar la localidad del domicilio"),
    });

    const { pasoUno } = useSelector(
        (state) => ({ pasoUno: state.pasoUno }),
        shallowEqual
    );

    const {
        actionsLoading,
        inscripcionId,
        responsables,
        error
    } = pasoUno;

    useEffect(() => {
        if (siguientePaso) {
            if (!actionsLoading && !error && tipo === "aspirante" && inscripcionId && currentStep === 1) {
                scrollTop();
                setTimeout(() => {
                    setCantidad(cantidadResponsables());
                    nextStep();
                }, 400);
            };
            setSiguientePaso(false);
        };
    }, [actionsLoading, error, inscripcionId]);

    useEffect(() => {
        if (!actionsLoading && !error && tipo === "responsable" && responsables.length > 0) {
            setCantidad(cantidadResponsables());
            //setUltimoPaso(currentStep);
        };
    }, [actionsLoading, error, responsables, cantidadResponsables, currentStep]);

    const dispatch = useDispatch();
    return (
        <PreInscripcionUIConsumer>
            {value =>
                <>
                    <div className="d-flex flex-row justify-content-between">
                        <p className="font-weight-bold">Domicilio de Residencia</p>
                        <p className="text-muted">(*)Campos Obligatorios</p>
                    </div>
                    <Formik
                        enableReinitialize
                        initialValues={tipo === "responsable" ? value.valoresDomicilioResponsable(posicion) : value.valoresDomicilioAspirante()}
                        validationSchema={domicilioSchema}
                        onSubmit={(values, { setSubmitting }) => {
                            setTimeout(() => {
                                //console.log(values);
                                if (tipo === "aspirante") {
                                    value.dispatchDatosPeronales({ type: 'guardarAspiranteDomicilio', payload: values });
                                    const { sexo, documentoNumero: nroDocumento, registroCivilvalidacion: validadoPorElRegistroCivil } = value.valoresDocumentacionAspirante();
                                    const { nombre, apellido, pais, provincia, localidad: localidadNacimiento, fechaNacimiento: fNacimiento } = value.valoresDatosPersonalesAspirante();
                                    const { domicilioId, calle: domicilioCalle, numero: domicilioNumero, piso: domicilioPiso, dpto: domicilioDpto, departamento: domicilioDepartamento, localidad: domicilioLocalidad } = value.valoresDomicilioAspirante();
                                    const fechaNacimiento = fNacimiento.toISOString();
                                    const { 
                                        personaRegistroCivilId, inscripcionNumero, inscripcionId, id,
                                        inscripcionVinculadaNumero, inscripcionVinculadaId 
                                    } = value.valoresExtrasAspirante();

                                    let inscripcionVinculadaIdAUX = inscripcionVinculadaId ?? 0;
                                    let inscripcionIdAUX = inscripcionId ?? 0;

                                    if (inscripcionVinculadaIdAUX > 0 && inscripcionVinculadaIdAUX !== inscripcionIdAUX) {
                                        enqueueSnackbar(`El aspirante ya se encuentra inscripto. Código de inscripción: ${inscripcionVinculadaNumero}`, 
                                            {
                                                variant: 'error',
                                                preventDuplicate: true,
                                                autoHideDuration: 4000,
                                                onClose: null,
                                                anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }
                                            }
                                        );
                                    } else {
                                        dispatch(actions.fetchPasoUnoAlDos({
                                            id,
                                            sexo, nroDocumento, nombre, apellido, fechaNacimiento, paisNacimiento: paises[pais].countryName, provinciaNacimiento: paises[pais].regions[provincia].name, localidadNacimiento,
                                            domicilioId, domicilioCalle, domicilioNumero, domicilioPiso, domicilioDpto, domicilioDepartamento, domicilioLocalidad,
                                            validadoPorElRegistroCivil, personaRegistroCivilId, inscripcionNumero, inscripcionId
                                        }));
                                        setSiguientePaso(true);
                                    }
                                };
                                if (tipo === "responsable") {
                                    values.posicion = posicion;
                                    value.dispatchDatosPeronales({ type: 'guardarResponsableDomicilio', payload: values });
                                    /*props.setCantidad(value.cantidadResponsables());
                                    value.setUltimoPaso(props.currentStep);*/
                                    //console.log(value.valoresDatosPersonalesResponsable(posicion));
                                    scrollTop();
                                    setTimeout(() => {
                                        nextStep();
                                    }, 400);
                                };
                                setSubmitting(false);
                            }, 400);
                        }}
                    >
                        {formik =>
                            <Form>
                                <div className="row justify-content-between align-items-top">
                                    <div className="form-group col-12 col-sm-5">
                                        <label htmlFor="calle">Ingresar Calle*</label>
                                        <Field name="calle" className="form-control" placeholder="Calle" value={formik.values.calle} maxLength={value.maxCalle} />
                                        <div className="text-danger"><ErrorMessage name="calle" /></div>
                                    </div>
                                    <div className="form-group col-12 col-sm-5">
                                        <label htmlFor="numero">Ingresar Número*</label>
                                        <Field name="numero" className="form-control" placeholder="Número" value={formik.values.numero} maxLength={value.maxNumero} />
                                        <div className="text-danger"><ErrorMessage name="numero" /></div>
                                    </div>
                                </div>
                                <div className="row justify-content-between align-items-top">
                                    <div className="form-group col-12 col-sm-5">
                                        <label htmlFor="piso">Ingresar Piso</label>
                                        <Field name="piso" className="form-control" placeholder="Piso" value={formik.values.piso} maxLength={value.maxPiso} />
                                        <div className="text-danger"><ErrorMessage name="piso" /></div>
                                    </div>
                                    <div className="form-group col-12 col-sm-5">
                                        <label htmlFor="dpto">Ingresar Dpto</label>
                                        <Field name="dpto" className="form-control" placeholder="Dpto" value={formik.values.dpto} maxLength={value.maxDepartamento} />
                                        <div className="text-danger"><ErrorMessage name="dpto" /></div>
                                    </div>
                                </div>
                                <div className="row justify-content-between align-items-top">
                                    <div className="form-group col-12 col-sm-5">
                                        <label htmlFor="departamento">Ingresar Departamento</label>
                                        <Field name="departamento" className="form-control" placeholder="Departamento" value={formik.values.departamento} maxLength={value.maxDepartamento} />
                                        <div className="text-danger"><ErrorMessage name="departamento" /></div>
                                    </div>
                                    <div className="form-group col-12 col-sm-5">
                                        <label htmlFor="localidad">Ingresar Localidad*</label>
                                        <Field name="localidad" type="text" className="form-control" placeholder="Localidad" value={formik.values.localidad} maxLength={value.maxLocalidad} />
                                        <div className="text-danger"><ErrorMessage name="localidad" /></div>
                                    </div>
                                </div>

                                <div className="row justify-content-center mb-3">
                                    <Volver ultimoPaso={1} {...props} />
                                    <Continuar tipo="guardar" spinner={actionsLoading} />
                                </div>
                                {error && <SnackBarCustom tipo="error" mensaje={error} />}
                            </Form>
                        }
                    </Formik>
                </>
            }
        </PreInscripcionUIConsumer>
    )
}

export default Domicilio;